import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import dashboardRoutes from "../../routes/routes/routes";
import FinanzasRoutes from "../../routes/routes_General/routes";


import "./style.css";
var inactivityTime = function () {
  var time;
  window.onload = resetTimer;


  document.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onmousedown = resetTimer; 
  document.ontouchstart = resetTimer;
  document.onclick = resetTimer; 
  document.onscroll = resetTimer; 
  document.onkeypress = resetTimer;

  function logout() {
    console.log("You are now logged out.");
    localStorage.removeItem("token");
  }

  function resetTimer() {
    clearTimeout(time);
    time = setTimeout(logout, 600000);
  }
};
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      visible: false,
      show: true,
      showMenu: false,
      other: false,
      showMenusStast: false,
      firstname: "",
      lastname: "",
      showMenuSummary: false,
      showMenuUser: false,

      showVentas: false,
      showproduccion: false,
      showCompras: false,
      

      showAutorizaciones: false,
      showLogistica: false,

      showuserAdministration: false,      
      valueSearch: "",
    };
  }
  handleSearch = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  keepTheSubmenusOpen() {
    if (
      window.location.href.includes("/reporte") ||
      window.location.href.includes("/planilla")
    ) {
      this.setState({
        showVentas: true,
        showproduccion: false,
        showCompras: false,
        showAutorizaciones: false,
        showLogistica: false,
        showuserAdministration: false,   
      });
    }
    if (window.location.href.includes("/reporte")) {
      this.setState({
        showproduccion: true,
        showVentas: false,
        showCompras: false,        
        showAutorizaciones: false,
        showLogistica: false,
        showuserAdministration: false,  
      });
    }  
    if (window.location.href.includes("/reporte")) {
      this.setState({
        showCompras: true,
        showproduccion: false,
        showVentas: false,
        showAutorizaciones: false,
        showLogistica: false,
        showuserAdministration: false,  
      });
    }
    if (window.location.href.includes("/reporte")) {
      this.setState({
        showAutorizaciones: true,
        showproduccion: false,
        showVentas: false,
        showCompras: false,        
        showLogistica: false,
        showuserAdministration: false,  
      });
    }  
    if (window.location.href.includes("/reporte")) {
      this.setState({
        showLogistica: true,
        showAutorizaciones: false,
        showproduccion: false,
        showVentas: false,
        showCompras: false,  
        showuserAdministration: false,  
      });
    } 

    if (window.location.href.includes("/reporte")) {
      this.setState({
        showuserAdministration: true,
        showVentas: false,
        showproduccion: false,
        showCompras: false,
        showLogistica: false,
        showAutorizaciones: false,

      });
    }   
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentWillMount() {
    this.keepTheSubmenusOpen();
    this.updateDimensions();
    window.onload = function () {
      inactivityTime();
    };
  }

  showVentasSubmenus(event) {
    event.preventDefault();
    this.setState({
      showVentas: !this.state.showVentas,
      showproduccion: false,
      showCompras: false,
      showAutorizaciones: false,
      showLogistica: false
    });
  }
  showproduccion(event) {
    event.preventDefault();
    this.setState({
      showproduccion: !this.state.showproduccion,
      showVentas: false,
      showCompras: false,
      showAutorizaciones: false,
      showLogistica: false

    });
  }

  showCompras(event) {
    event.preventDefault();
    this.setState({
      showCompras: !this.state.showCompras,
      showproduccion: false,
      showVentas: false,
      showAutorizaciones: false,
      showLogistica: false,
    });
  }

  showAutorizaciones(event) {
    event.preventDefault();
    this.setState({
      showAutorizaciones: !this.state.showAutorizaciones,
      showproduccion: false,
      showVentas: false,
      showCompras: false,
      showLogistica: false,
    });
  }

  showLogistica(event) {
    event.preventDefault();
    this.setState({
      showLogistica: !this.state.showLogistica,
      showproduccion: false,
      showVentas: false,
      showCompras: false,
      showAutorizaciones: false,
    });
  }
  
  showuserAdministration(event) {
    event.preventDefault();
    this.setState({
      showuserAdministration: !this.state.showuserAdministration,
      showVentas: false,
      showproduccion: false,
      showCompras: false,
      showLogistica: false
    });
  }
  
  clearState = () => {
    this.setState({
      showVentas: false,
      showproduccion: false,
      showCompras: false,
      showAutorizaciones: false,
      showLogistica: false

    });
  };
  render() {
    let token = localStorage.getItem("token");
    let token_Data = JSON.parse(token);

    if (token_Data === null) {
      this.props.history.push("");
    }

    const sidebarBackground = {
      backgroundImage: "url(" + this.props.image + ")",
    };
    const Styles = {
      text: {
        color: "white",
        fontSize: "9px",
      },
      title: {
        color: "white",
        fontSize: "10px",
      },
    };
    var nameUser = "";
    var available = "";
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        nameUser = element.Nombre;
        available = element.is_available;
      });
    }
    if (parseInt(available) === 0) {
      this.props.history.push("");
    }

    let test_new_routes = [];
    if (nameUser !== "admin" && nameUser !== "ventas" && token_Data !== null) {
      FinanzasRoutes.forEach((element) => {
        
         
        token_Data.forEach((element_user) => {
          nameUser = element_user.Nombre;
          let temp_groups = JSON.parse(element_user.GrpReporte);
          console.log(element_user.GrpReporte);
          temp_groups.forEach((element_name_user) => {
            if (parseInt(element.id) === element_name_user) {
              if (element_name_user === 1) {
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: element.component,
                };

                test_new_routes.push(ruta);
              }             
              if (element_name_user === 2) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };

                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 3) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 4) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 5) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 6) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 7) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 8) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 9) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 10) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 11) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 12) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }

              if (element_name_user === 13) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 14) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
              if (element_name_user === 15) {
                let component = [];
                let ruta = {
                  path: element.path,
                  name: element.name,
                  icon: element.icon,
                  component: component,
                };
                let temp_reports = JSON.parse(element_user.RepId);
                let number = temp_reports.length;
                for (let idx = 0; idx < number; idx++) {
                  let nameReporte = temp_reports[idx];
                  element.component.forEach((element_component) => {
                    if (parseInt(element_component.id) === nameReporte) {
                      component.push(element_component);
                    }
                  });
                }
                test_new_routes.push(ruta); 
              }
            }
          });
        });
      });
    }

    /* ----------------------Inicio Funcion para filtrar reportes ----------------------  */
    let newTempObjReport = [];
    let HomeComponente;
    test_new_routes.forEach((element) => {
      if (element.path === "/home") {
        HomeComponente = element;
      }
      newTempObjReport.push(element.component);
    });
    let flatArr = newTempObjReport.flat();

    const filteredUsers = flatArr.filter((report) => {
      if (report.name !== undefined) {
        return report.name
          .toLowerCase()
          .includes(this.state.valueSearch.toLowerCase());
      } else {
        return report;
      }
    });
    let FilterNewDataReports = getRoutes(filteredUsers);
    function getRoutes(paramsComponente) {
      let newReport = [HomeComponente];
      for (let element of FinanzasRoutes) {
        let dataReport = getRoutesId(
          element.path,
          element.name,
          element.icon,
          paramsComponente
        );
        if (dataReport !== undefined) {
          newReport.push(dataReport);
        }
      }
      return newReport;
    }
    function getRoutesId(path, name, icon, paramsReport) {
      let d = paramsReport.filter((res) => res.grupoDependiente === path);
      if (d.length > 0) {
        let ruta = {
          path: path,
          name: name,
          icon: icon,
          component: d,
        };
        return ruta;
      }
    }

    /* ----------------------Fin Funcion para filtrar reportes ----------------------  */

    let new_Arr_reports = [];
    if (token_Data !== null) {
      if (
        token_Data[0].UserCode === 28 ||
        token_Data[0].UserCode === 26 ||
        token_Data[0].UserCode === 39 ||
         token_Data[0].UserCode === 27
      ) {
        let rhome = FilterNewDataReports.find((res) => res.path === "/home");
        let r1 = FilterNewDataReports.find((res) => res.path === 7);
        let r2 = FilterNewDataReports.find((res) => res.path === 5);
        let r3 = FilterNewDataReports.find((res) => res.path === 0);
        let r4 = FilterNewDataReports.find((res) => res.path === "");
        let r5 = FilterNewDataReports.find((res) => res.path === 3);
        let r6 = FilterNewDataReports.find((res) => res.path === 4);
        let r7 = FilterNewDataReports.find((res) => res.path === 6);
        let r8 = FilterNewDataReports.find((res) => res.path === 8);
        let r9 = FilterNewDataReports.find((res) => res.path === 9);
        let r10 = FilterNewDataReports.find((res) => res.path === 1);
        let r11 = FilterNewDataReports.find((res) => res.path === 2);
        //----- NUEVO -------
        let r13 = FilterNewDataReports.find((res) => res.path === 13);
        let r14 = FilterNewDataReports.find((res) => res.path === 14);
        let r15 = FilterNewDataReports.find((res) => res.path === 15);
        //--- FIN NUEVO -----

        new_Arr_reports.push(rhome);
        new_Arr_reports.push(r1);
        new_Arr_reports.push(r2);
        new_Arr_reports.push(r3);
        new_Arr_reports.push(r4);
        new_Arr_reports.push(r5);
        new_Arr_reports.push(r6);
        new_Arr_reports.push(r7);
        new_Arr_reports.push(r8);
        new_Arr_reports.push(r9);
        new_Arr_reports.push(r10);
        new_Arr_reports.push(r11);
        //----- NUEVO -------
        new_Arr_reports.push(r13);
        new_Arr_reports.push(r14);
        new_Arr_reports.push(r15);
        //--- FIN NUEVO -----
      }
      if (
        token_Data[0].UserCode !== 28 &&
        token_Data[0].UserCode !== 26 &&
        token_Data[0].UserCode !== 39
      ) {
        new_Arr_reports = FilterNewDataReports;
      }
    }
    let new_Arr_reports_filter = new_Arr_reports.filter(
      (res) => res !== undefined
    );

    const AdminSidebar = (
      <div className="sidebar-wrapper">
        <nav id="supervisor">
          {dashboardRoutes.map((prop, key) => {
            if (!prop.redirect)
              return prop.path === 3 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showVentasSubmenus.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showVentas !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={this.state.showVentas ? "visible" : "no-visible"}
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Ventas" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              ) : prop.path === 2 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showproduccion.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showproduccion !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={
                            this.state.showproduccion ? "visible" : "no-visible"
                          }
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Produccion" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              )               
              : prop.path === 11 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showCompras.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showCompras !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={this.state.showCompras ? "visible" : "no-visible"}
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Compras" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              ) 
              : prop.path === 12 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showAutorizaciones.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showAutorizaciones !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={this.state.showAutorizaciones ? "visible" : "no-visible"}
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Autorizaciones" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              ) 
              : prop.path === 13 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showLogistica.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showLogistica !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={this.state.showLogistica ? "visible" : "no-visible"}
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Logistica" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              ) 
              : prop.path === "user" ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a
                      onClick={this.showuserAdministration.bind(this)}
                      href="/"
                    >
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showuserAdministration !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={
                            this.state.showuserAdministration
                              ? "visible"
                              : "no-visible"
                          }
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "User Administration"
                                  ? ""
                                  : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              ) : prop.doNotShow ? (
                ""
              ) : (
                <ul className="nav" key={key}>
                  <li
                    className={
                      prop.upgrade
                        ? "active active-pro"
                        : this.activeRoute(prop.path)
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.path}
                      className="nav-link"
                      activeClassName="active"
                      onClick={() => this.clearState()}
                    >
                      <i className={prop.icon} />
                      <p style={Styles.title}>{prop.name}</p>
                    </NavLink>
                  </li>
                </ul>
              );
            return null;
          })}
        </nav>
      </div>
    );
    const FinanzasSidebar = (
      <div className="sidebar-wrapper">
        <nav id="supervisor">
          {new_Arr_reports_filter.map((prop, key) => {
            if (!prop.redirect)
              return prop.path === 3 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showVentasSubmenus.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showVentas !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={this.state.showVentas ? "visible" : "no-visible"}
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Ventas" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              ) 
              : prop.path === 2 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showproduccion.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showproduccion !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={
                            this.state.showproduccion ? "visible" : "no-visible"
                          }
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Produccion" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              )
              : prop.path === 11 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showCompras.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showCompras !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={this.state.showCompras ? "visible" : "no-visible"}
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Compras" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              )
              : prop.path === 12 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showAutorizaciones.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showAutorizaciones !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={
                            this.state.showAutorizaciones ? "visible" : "no-visible"
                          }
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Autorizaciones" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              )
              : prop.path === 13 ? (
                <ul key={key} className="nav">
                  <li key={key}>
                    <a onClick={this.showLogistica.bind(this)} href="/">
                      <i className={prop.icon} />
                      <i
                        className={
                          this.state.showLogistica !== true
                            ? "pe-7s-angle-down"
                            : "pe-7s-angle-up"
                        }
                        style={{ float: "right" }}
                      />
                      <p style={Styles.title}>{prop.name}</p>
                    </a>
                    {prop.component.map((res, index) => {
                      return (
                        <ul
                          id={
                            this.state.showLogistica ? "visible" : "no-visible"
                          }
                          key={index}
                        >
                          <li key={index}>
                            <NavLink
                              to={res.path}
                              className="nav-link"
                              activeClassName="active"
                            >
                              <i className={res.icon} />
                              <p style={Styles.text}>
                                {res.name === "Logistica" ? "" : res.name}
                              </p>
                            </NavLink>
                          </li>
                        </ul>
                      );
                    })}
                  </li>
                </ul>
              )
              : prop.doNotShow ? (
                ""
              ) : (
                <ul className="nav" key={key}>
                  <li
                    className={
                      prop.upgrade
                        ? "active active-pro"
                        : this.activeRoute(prop.path)
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.path}
                      className="nav-link"
                      activeClassName="active"
                      onClick={() => this.clearState()}
                    >
                      <i className={prop.icon} />
                      <p style={Styles.title}>{prop.name}</p>
                    </NavLink>
                  </li>
                </ul>
              );
            return null;
          })}
        </nav>
      </div>
    );
    return (
      <div
        id="sidebar"
        className="sidebar"
        data-color={this.props.color}
        data-image={this.props.image}
      >
        {this.props.hasImage ? (
          <div className="sidebar-background" style={sidebarBackground} />
        ) : null}
        <div className="logo">
          <a
            href="/home"
            className="simple-text logo-normal"
            style={{ textAlign: "center" }}
          >
            TRANSFLESA
          </a>
          <div style={{ textAlign: "center" }}>
            {nameUser}
            {token_Data !== null ? token_Data.Nombre : ""}
          </div>
          {token_Data !== null ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {nameUser !== "admin" ? (
                <input
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    border: "2px solid black",
                  }}
                  type="text"
                  name="searchReport"
                  id="searchReport"
                  placeholder="Buscar ...."
                  value={this.state.valueSearch}
                  onChange={(e) =>
                    this.setState({ valueSearch: e.target.value })
                  }
                />
              ) : null}
            </div>
          ) : null}
        </div>

        {token_Data !== null ? (
          <div>
            {nameUser === "admin"
              ? AdminSidebar
              : nameUser !== "admin" && nameUser !== "ventas"
              ? FinanzasSidebar
              : ""}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
Sidebar.propTypes = {};
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps)(Sidebar);
